module.exports = __webpack_public_path__ + "img/pixing_xc19.3a7dd699.jpg";